module.exports = __webpack_public_path__ + "static/sparda-muenchen-1596efc129754a9ef637bc68c48ca4ad.png";